import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));
/* `oauthError`: why a Google/Discord sign-in just failed, handed from
   AuthCallback to Login. A store field rather than DisplayMessage (the router
   guard wipes that on every navigation) or a /login query param (which would
   let any link print arbitrary text on the sign-in page). Login reads it once
   and clears it. */
const initialState = user
  ? { status: { loggedIn: true }, user, loading: false, oauthError: "", logoutModal: { show: false, title: '', message: '', showLogoutButton: false } }
  : { status: { loggedIn: false }, user: null, loading: false, oauthError: "", logoutModal: { show: false, title: '', message: '', showLogoutButton: false } };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    toggleLoading({ commit }) {
      commit("toggleLoading")
    },
    login({ commit }, user) {
      // If user already has access_token, it's coming from Google OAuth
      if (user.access_token) {
        commit("loginSuccess", user);
        return Promise.resolve(user);
      }
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    updateUser({ commit }, user) {
      commit("toggleLoading");
      commit("updateUser", user);
    },
    /* TwoFactorSettings has always dispatched `auth/getUser` after enabling or
       disabling 2FA, but no such action existed — Vuex logged "unknown action
       type" and the card kept showing the old on/off state until a reload. */
    getUser() {
      return AuthService.getUser();
    },
    setOauthError({ commit }, message) {
      commit("setOauthError", message);
    },
    isExpired({ commit }, user) {
      AuthService.isTokenExpired();
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    sessionExpired({ commit, state }) {
      // Session is dead server-side: drop credentials immediately.
      AuthService.logout();
      commit("logout");
      if (!state.logoutModal.show) {
        commit("showLogoutModal", {
          title: "Session expired",
          message: "Your login session has expired. Please sign in again to continue where you left off.",
          showLogoutButton: true,
        });
      }
    },
    refreshToken({ commit }, accessToken) {
      commit("refreshToken", accessToken);
    },
    register({ commit }, user) {
      // The browser used to follow a successful registration with
      // `ZapierService.create({ email })` — a fire-and-forget POST to a separate
      // unauthenticated webhook, telling it the address the backend had just
      // written to `users` itself. It is gone: the backend adds the address to
      // the mailing list inside POST /api/auth/register (src/server/signup.ts).
      // Nothing replaces this call here; do not add one.
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
    showLogoutModal({ commit }, modalData) {
      commit("showLogoutModal", modalData);
    },
    hideLogoutModal({ commit }) {
      commit("hideLogoutModal");
    },
  },
  mutations: {
    toggleLoading(state) {
      state.loading = !state.loading;
    },
    refreshToken(state, user, access_token) {
      state.status.loggedIn = true;
      state.user = { ...user, access_token: access_token };
    },
    updateUser(state, user) {
      state.user.user = user;
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    showLogoutModal(state, modalData) {
      state.logoutModal = {
        show: true,
        title: modalData.title,
        message: modalData.message,
        showLogoutButton: modalData.showLogoutButton
      };
    },
    hideLogoutModal(state) {
      state.logoutModal = {
        show: false,
        title: '',
        message: '',
        showLogoutButton: false
      };
    },
    setOauthError(state, message) {
      state.oauthError = typeof message === "string" ? message : "";
    },
  },
};
